/**
 * Used when connection to server could not be established, so there is no response for request.
 */
export class NetworkError {
    public readonly name = 'NetworkError';
    public readonly message: string;

    constructor(error: unknown) {
        this.message = error instanceof Error ? error.message : String(error);
    }
}
